import { z } from "zod";

export const loginschema = z.object({
    email: z
        .string()
        .min(1, { message: "must provide an email" })
        .email({ message: "Invalid email format" }),
    password: z.string().min(8, { message: "must provide a password" }).max(70),
});
export type Login = z.infer<typeof loginschema>


export const resetPasswordschema = z.object({
    oldPassword: z.string().min(8, { message: "must provide the old password" }).max(70),
    newPassword: z.string().min(8, { message: "must provide a new password" }).max(70),
    confirmNewPassword: z.string().min(8, { message: "must provide the new password again" }).max(70),
});

export type ResetPassword = z.infer<typeof resetPasswordschema>


export const forgetPasswordSchema = z.object({
    email: z
        .string()
        .min(1, { message: "must provide an email" })
        .email({ message: "Invalid email format" }),
});
export type ForgetPassword = z.infer<typeof forgetPasswordSchema>